'use client';
// @spec authentication-pwa-install

export type InstallSurface = 'chromium' | 'safari-macos' | 'safari-ios' | 'unsupported';

/**
 * Detects which PWA install surface is available in the current browser.
 * Returns 'chromium' for Chrome/Edge (non-iOS), 'safari-macos' or 'safari-ios' for Safari,
 * or 'unsupported' for browsers without PWA install capability (e.g. Firefox, CriOS on iOS).
 */
export function detectInstallSurface(): InstallSurface {
  const userAgent = navigator.userAgent;
  const vendor = navigator.vendor;
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isMacOS = /Mac/.test(navigator.platform) && !isIOS;
  const isSafari =
    /Safari/.test(userAgent) && /Apple/.test(vendor) && !/CriOS|Chrome|Edg|OPR/.test(userAgent);
  const isChromium = /Chrome|CriOS|Edg/.test(userAgent);

  if (isSafari && isIOS) {
    return 'safari-ios';
  }

  if (isSafari && isMacOS) {
    return 'safari-macos';
  }

  // CriOS on iOS uses WKWebView and cannot trigger beforeinstallprompt
  if (isChromium && !isIOS) {
    return 'chromium';
  }

  return 'unsupported';
}
